// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.energy-loss-chart-modal::part(part-header) {
    border-bottom: 1px solid #e0e0e0;
}
`, "",{"version":3,"sources":["webpack://./src/components/AssetPortfolio/EnergyLossChartModal.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;AACpC","sourcesContent":[".energy-loss-chart-modal::part(part-header) {\n    border-bottom: 1px solid #e0e0e0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
